import { ClientHelper } from '../client/CreateNswagClient';
import { ConfigUpdateModel } from '../client/SmartAssistantBackendClient';

export class AdminConfigService {
  static async loadAdminViewModel(token: string) {
    const client = ClientHelper.createNswagClient(token);
    return client.loadAdminViewModel();
  }

  static async loadFrontendViewModel(token: string) {
    const client = ClientHelper.createNswagClient(token);
    return client.loadFrontendViewModel();
  }

  static async updateApiKey(token: string, openAiKey: string) {
    const configClient = ClientHelper.createConfigClient(token);
    await configClient.updateApiKey(new ConfigUpdateModel({ openAiKey }));
  }

  static async updateFrontendConfig(token: string, payload: {
    profileFile?: string;
    systemPrompt?: string;
    profileSystemPrompt?: string;
  }) {
    const apiClient = ClientHelper.createNswagClient(token);
    await apiClient.updateFrontendConfig(new ConfigUpdateModel(payload));
  }
}
